import { render, staticRenderFns } from "./triangleBtn.vue?vue&type=template&id=35af9c67"
import script from "./triangleBtn.vue?vue&type=script&lang=js"
export * from "./triangleBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports